export default {
  /** 我的徽章主页（本人态 / 分享态） */
  BADGE_HOME: '/api/v3/contest/badge/home',
  /** 领取徽章 */
  BADGE_CLAIM: '/api/v3/contest/badge/claim',
  /** 徽章凭证详情 */
  BADGE_DETAIL: '/api/v3/contest/badge/detail',
  /** 发证机构主页 */
  BADGE_INSTITUTION_HOME: '/api/v3/contest/badge/institution/home',
  /** 企业徽章简介详情 */
  BADGE_INTRO_DETAIL: '/api/v3/contest/badge/intro/detail',
  /** 领英添加认证跳转链接 */
  BADGE_LINKEDIN_REDIRECT: '/api/v3/contest/badge/linkedin/redirect'
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/badges.js